import { getErrorLogs, setErrorLogs } from "./ErrorLogAction";

const dispatchGetErrorLogs = (dispatch: Function) => (value:any) => {
    dispatch(getErrorLogs(value));
}
const dispatchSetErrorLogs = (dispatch: Function) => (value:any) => {
    dispatch(setErrorLogs(value));
}

const ErrorLogDisptch = {
    dispatchSetErrorLogs,
    dispatchGetErrorLogs    
    
};

export default ErrorLogDisptch